export default "__VITE_ASSET__DWPNV$JE__ 480w, __VITE_ASSET__BDnFaCqi__ 768w, __VITE_ASSET__DHwHXtG8__ 1200w, __VITE_ASSET__DXkFfuTm__ 1920w";